import { memo, useCallback, useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getCompanyBalanceSheetData, getCompanyResultData, getProfitLossData } from "../../redux/actions/marketOverview";
import { deepClone, getAssetExchangeNameFromMktSegId, getScripDisplayDescription } from "../../utils/global_functions";
import { WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { AgGridReact } from "ag-grid-react";
import ZeroStates from "../ZeroStates";

const AnnualReport = () => {
  // Vaibhav Singh: BT-116661: 28-08-2023: Button Implemented For Peer Comprasion
  const [selectedTab, setSelectedTab] = useState(0);
  const [showMore, setShowMore] = useState(false);
  const scripOverviewData = useSelector(
    (state) => state.marketOverview.scripOverviewData
  );
  const profitLossData = useSelector(
    (state) => state.marketOverview.profitLossData
  );
  const balanceSheetdata = useSelector((state) => state.marketOverview.companyBalanceSheetData);
  const companyResultData = useSelector((state) => state.marketOverview.companyResultData);
  const dispatch = useDispatch();
  const [toggleData, setToggleData] = useState([]);
  // Vaibhav Singh: BT-109095:09-11-23:Fixed a Spelling: Start
  const annualReportTabs = [
    {
      id: 0,
      tabName: "Profit & Loss",
      reportType: "ProfitLoss",
    },
    {
      id: 1,
      tabName: "Balance Sheet",
      reportType: "BalanceSheet"
    },
    {
      id: 2,
      tabName: "Results",
      reportType: "Results"
    },
  ];
  // Vaibhav Singh: BT-109095:09-11-23:Fixed a Spelling: End

  useEffect(() => {
    const exchangeType = getAssetExchangeNameFromMktSegId(
      scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID]
    );
    const objPayload = {
      mktSegmentId: exchangeType,
      nToken: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
      jtenantToken: 1,
      exchangeType: exchangeType
    };
    if (profitLossData?.length === 0 && selectedTab === 0) {
      dispatch(
        getProfitLossData(objPayload)
      );
    }
    //BT-109095: Functional Implementation : Vaibhav Singh : 26-07-2023 : Added toggle logic for Profit&Loss, CompanyBalanceSheet and COmpany result API 
    if (profitLossData?.length > 0 && selectedTab === 0) {
      //Vaibhav Singh : BT-109095: 20-11-23: Fixed decimal locator Issue in Annual rport: Start
      let newProfit = deepClone(profitLossData);
      newProfit?.forEach((each, i) => {
        if (i !== 0) {
          Object.keys(each)?.forEach((item) => {
            if (item !== "ColumnName") {
              each[item] = parseFloat(each[item]).toLocaleString();
            }
          });
        }
      });
      //Vaibhav Singh : BT-109095: 20-11-23: Fixed decimal locator Issue in Annual rport: End
      setToggleData(newProfit);
    }
    if (balanceSheetdata?.length > 0 && selectedTab === 1) {
      //Vaibhav Singh : BT-109095: 20-11-23: Fixed decimal locator Issue in Annual rport: Start
      let newBalanceSheetData = deepClone(balanceSheetdata);
      newBalanceSheetData?.forEach((each, i) => {
        if (i !== 0) {
          Object.keys(each)?.forEach((item) => {
            if (item !== "ColumnName") {
              each[item] = parseFloat(each[item]).toLocaleString();
            }
          });
        }
      });
      //Vaibhav Singh : BT-109095: 20-11-23: Fixed decimal locator Issue in Annual rport: End
      setToggleData(newBalanceSheetData);
    }
    if (companyResultData?.length > 0 && selectedTab === 2) {
      //Vaibhav Singh : BT-109095: 20-11-23: Fixed decimal locator Issue in Annual rport: Start
      let newCompayResult = deepClone(companyResultData);
      newCompayResult?.forEach((each, i) => {
        if (i !== 0) {
          Object.keys(each)?.forEach((item) => {
            if (item !== "ColumnName") {
              each[item] = parseFloat(each[item]).toLocaleString();
            }
          });
        }
      });
      //Vaibhav Singh : BT-109095: 20-11-23: Fixed decimal locator Issue in Annual rport: End
      setToggleData(newCompayResult);
    }
    if (balanceSheetdata?.length === 0 && selectedTab === 1) {
      dispatch(getCompanyBalanceSheetData(objPayload));
    }
    if (companyResultData?.length === 0 && selectedTab === 2) {
      dispatch(getCompanyResultData(objPayload));
    }
  }, [balanceSheetdata, companyResultData, dispatch, profitLossData, scripOverviewData, selectedTab]);
  const gridRef = useRef();
  const defaultColDef = {
    width: 100,
    menuTabs: [],
    flex: 1
  };

  const HeaderComponent = ({ className, children }) => {
    return <div className={className}>{children}</div>;
  };

  const columnDefs = (toggleData?.length ? toggleData[0]?.CurrentFinYr !== undefined : false) ? [
    { headerName: "Particulars", field: "ColumnName", width: 167, cellClass: "annual-reports-cell-left", suppressMovable: true, resizable: true, headerComponent: () => <HeaderComponent className={'font-regular font-size3 color-text text-start w-100'}>Averages</HeaderComponent> },
    { field: "CurrentFinYr", width: 167, cellClass: "annual-reports-cell-center", headerComponent: () => <HeaderComponent className={'font-regular font-size3 color-text text-center w-100'}>{toggleData?.length ? new Date(toggleData[0]?.CurrentFinYr?.slice(-2)).toLocaleDateString('en-US', { 'month': 'short' }).toUpperCase() + " " + toggleData[0]?.CurrentFinYr?.slice(0, -2) + "(Cr.)" : '-'}</HeaderComponent>, suppressMovable: true },
    { field: "YOY_1", width: 167, cellClass: "annual-reports-cell-center", headerComponent: () => <HeaderComponent className='font-regular font-size3 color-text text-center w-100'>{toggleData?.length ? new Date(toggleData[0]?.YOY_1?.slice(-2)).toLocaleDateString('en-US', { 'month': 'short' }).toUpperCase() + " " + toggleData[0]?.YOY_1?.slice(0, -2) + "(Cr.)" : '-'}</HeaderComponent>, suppressMovable: true },
  ] : [
    { headerName: "Particulars", field: "ColumnName", width: 167, cellClass: "annual-reports-cell-left", suppressMovable: true, resizable: true, headerComponent: () => <HeaderComponent className={'font-regular font-size3 color-text text-start w-100'}>Averages</HeaderComponent> },
    { field: "CurrentYear", width: 167, cellClass: "annual-reports-cell-center", headerComponent: () => <HeaderComponent className={'font-regular font-size3 color-text text-center w-100'}>{toggleData?.length ? new Date(toggleData[0]?.CurrentYear?.slice(-2)).toLocaleDateString('en-US', { 'month': 'short' }).toUpperCase() + " " + toggleData[0]?.CurrentYear?.slice(0, -2) + "(Cr.)" : '-'}</HeaderComponent>, suppressMovable: true },
    { field: "Year1", width: 167, cellClass: "annual-reports-cell-center", headerComponent: () => <HeaderComponent className={'font-regular font-size3 color-text text-center w-100'}>{toggleData?.length ? new Date(toggleData[0]?.Year1?.slice(-2)).toLocaleDateString('en-US', { 'month': 'short' }).toUpperCase() + " " + toggleData[0]?.Year1?.slice(0, -2) + "(Cr.)" : '-'}</HeaderComponent>, suppressMovable: true },
  ];

  //Vaibhav Singh: BT-109095: 09-11-23:Added logic for date formating and uppercase and removing filter  : End
  const onExportMarketMovement = useCallback(() => {
    //Vaibhav Singh:04-01-23:BT-109095 Download button disabled in case of no data: Start
    if (toggleData?.length) {
      setShowMore(true);
      //Vaibhav Singh: BT-109095: 12-12:23: Export logic updated: Start
      setTimeout(() => {
        // Vaibhav Singh: BT-109095: Fixed filename for peercomparison: Start
        gridRef?.current?.api?.exportDataAsExcel({
          fileName: `${scripOverviewData?.[WATCHLIST_GRID_INDEX.SYMBOL]}_${scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE]}_${getScripDisplayDescription(scripOverviewData)?.split(" ")?.join("")}_AnnualReport_${annualReportTabs[selectedTab].reportType}.xlsx`,
          // Vaibhav Singh: BT-109095: Fixed filename for peercomparison: End
          processHeaderCallback: (params) => {
            if (params?.column?.colDef?.field === "CurrentFinYr") {
              return toggleData?.length ? new Date(toggleData[0]?.CurrentFinYr?.slice(-2)).toLocaleDateString('en-US', { 'month': 'short' }).toUpperCase() + " " + toggleData[0]?.CurrentFinYr?.slice(0, -2) + "(Cr.)" : '-';
            }
            if (params?.column?.colDef?.field === "YOY_1") {
              return toggleData?.length ? new Date(toggleData[0]?.YOY_1?.slice(-2)).toLocaleDateString('en-US', { 'month': 'short' }).toUpperCase() + " " + toggleData[0]?.YOY_1?.slice(0, -2) + "(Cr.)" : '-';
            }
            if (params?.column?.colDef?.field === "CurrentYear") {
              return toggleData?.length ? new Date(toggleData[0]?.CurrentYear?.slice(-2)).toLocaleDateString('en-US', { 'month': 'short' }).toUpperCase() + " " + toggleData[0]?.CurrentYear?.slice(0, -2) + "(Cr.)" : '-';
            }
            if (params?.column?.colDef?.field === "Year1") {
              return toggleData?.length ? new Date(toggleData[0]?.Year1?.slice(-2)).toLocaleDateString('en-US', { 'month': 'short' }).toUpperCase() + " " + toggleData[0]?.Year1?.slice(0, -2) + "(Cr.)" : '-';
            }
            return params?.column?.colDef?.headerName;
          }
        });
        //Vaibhav Singh: BT-109095: Export logic updated: End
      }, 2000);
    }
    //Vaibhav Singh:04-01-23: BT-109095Download button disabled in case of no data: End
  }, [scripOverviewData, toggleData]);
  // Vaibhav Singh: BT-116661: 28-08-2023: Expand button added
  // const handleExpand = () => {
  //   setIsExpand(!isExpand)
  //   handleMarketOverviewExpandOnclick()
  // }
  return (
    <Container data-testid="market-overview-annual-reports-section" fluid className='p-0 mt-3'>
      <div className='scripoverview-fieldset'>
        <div className='scripoverview-legend'>ANNUAL REPORTS</div>
        <Row className='g-0 mt-3'>
          <Col>
            <div className='d-flex submenu-wrapper pb-3'>
              {annualReportTabs.map((tb, index) => (
                <div data-testid={`market-overview-${tb.reportType}-tab`} key={index} className={
                  tb.id === selectedTab
                    ? 'font-size3 submenuItem active'
                    : 'submenuItem'
                }
                  onClick={() => {
                    setSelectedTab(tb.id);
                    if (tb.id === 0) {
                      let newProfit = deepClone(profitLossData);
                      newProfit?.forEach((each, i) => {
                        if (i !== 0) {
                          Object.keys(each)?.forEach((item) => {
                            if (item !== "ColumnName") {
                              each[item] = parseFloat(each[item]).toLocaleString();
                            }
                          });
                        }
                      });
                      setToggleData(newProfit?.length ? newProfit : []);
                    }
                    if (tb.id === 1) {
                      let newBalanceSheetData = deepClone(balanceSheetdata);
                      newBalanceSheetData?.forEach((each, i) => {
                        if (i !== 0) {
                          Object.keys(each)?.forEach((item) => {
                            if (item !== "ColumnName") {
                              each[item] = parseFloat(each[item]).toLocaleString();
                            }
                          });
                        }
                      });
                      setToggleData(newBalanceSheetData?.length ? newBalanceSheetData : []);
                    }
                    if (tb.id === 2) {
                      let newCompayResult = deepClone(companyResultData);
                      newCompayResult?.forEach((each, i) => {
                        if (i !== 0) {
                          Object.keys(each)?.forEach((item) => {
                            if (item !== "ColumnName") {
                              each[item] = parseFloat(each[item]).toLocaleString();
                            }
                          });
                        }
                      });
                      setToggleData(newCompayResult?.length ? newCompayResult : []);
                    }
                  }
                  }
                >
                  {tb.tabName}
                </div>
              ))}
            </div>
            {(toggleData?.length) ?
              <>
                <Row className='g-0'>
                  <Col>
                    <div data-testid="market-overview-annual-reports-grid" className='pt-2 ag-theme-alpine so-analysis-fundamental-anual-report'>
                      {(toggleData) ?
                        <AgGridReact
                          ref={gridRef}
                          defaultColDef={defaultColDef}
                          columnDefs={columnDefs}
                          rowData={toggleData?.slice(1)} />
                        : null}
                    </div>
                  </Col>
                </Row>
              </>
              :
              <div className='zero-state-alerts zero-state-alerts-lg'>
                <ZeroStates subText="Could not find any data" icon='icon-64 icon-nodata mb-3 mrgauto' />
              </div>}

            <div className='fixed-icons-wrapper'>
              <div className='d-flex justify-content-end align-items-center'>
                    <div className='background-icon focus p-1' onClick={() => onExportMarketMovement()}>
                  <div className={`icon-16 icon-download ${toggleData?.length ? 'icon-dark' : 'icon-grey'}`}></div>
                </div>
              </div>
            </div>

          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default memo(AnnualReport);











